import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router";

import { cn } from "@/utils/tailwind";

import type { CreatorCollection } from "../product/types";

interface CollectionCoverProps {
  className?: string;
  collection: CreatorCollection;
  to: string;
}

// Make the collection's title and cover the destination.
//
export function CollectionCover({
  className,
  collection,
  to,
}: CollectionCoverProps) {
  return (
    <Link
      data-accent={collection.accent}
      to={to}
      className={cn(
        "collection-cover group flex min-h-52 flex-col overflow-hidden rounded-2xl border transition-shadow hover:shadow-lg",
        className,
      )}
    >
      {collection.cover && (
        <img
          alt=""
          className="aspect-video w-full object-cover"
          loading="lazy"
          src={collection.cover}
        />
      )}
      <div className="relative z-10 flex flex-1 flex-col p-6">
        <div className="flex items-start gap-3">
          <h3 className="font-display flex-1 text-2xl font-semibold break-words">
            {collection.title}
          </h3>
          <ArrowUpRight className="mt-1 size-4 shrink-0" />
        </div>
        {collection.note && (
          <p className="collection-cover-description mt-3 line-clamp-3 text-sm leading-6">
            {collection.note}
          </p>
        )}
        <p className="collection-cover-meta mt-auto pt-5 text-xs">
          {collection.postIds.length}{" "}
          {collection.postIds.length === 1 ? "post" : "posts"}
        </p>
      </div>
    </Link>
  );
}
